import { render, staticRenderFns } from "./OrderRedirect.vue?vue&type=template&id=592b0c6e&"
import script from "./OrderRedirect.vue?vue&type=script&lang=js&"
export * from "./OrderRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports